import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';

import { sessionState } from '@chainlit/react-client';

type DownloadPayload = {
  name: string;
  mime?: string;
  content_b64: string;
};

function triggerDownload(payload: DownloadPayload) {
  try {
    const binary = atob(payload.content_b64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) {
      bytes[i] = binary.charCodeAt(i);
    }
    const blob = new Blob([bytes], {
      type: payload.mime || 'application/octet-stream'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = payload.name || 'report';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  } catch {
    return;
  }
}

export default function DownloadListener() {
  const session = useRecoilValue(sessionState);

  useEffect(() => {
    const socket = session?.socket;
    if (!socket) return;
    const handler = (payload: DownloadPayload) => {
      triggerDownload(payload);
    };
    socket.on('download_file', handler);
    return () => {
      socket.off('download_file', handler);
    };
  }, [session?.socket]);

  return null;
}
